import axios, { AxiosRequestConfig } from 'axios'
import convertToSnakeCase from '@Utils/ConvertToSnakeCase'

import {
  IDeleteProjectVersionsPayload,
  IUpdateProjectVersionTitlePayload,
} from './types'

const config: AxiosRequestConfig = {
  responseType: 'json'
}

export function deleteProjectVersions(payload: IDeleteProjectVersionsPayload) {
  return axios.delete(`/api/v1/project_versions/`,  { ...config, data: convertToSnakeCase(payload) })
}

export function updateProjectVersionTitle(payload: IUpdateProjectVersionTitlePayload) {
  return axios.put(`/api/v1/project_versions/${payload.projectVersionId}/update_title`, convertToSnakeCase(payload), config)
}
